export default __webpack_public_path__ + "static/media/to-do-list-mobile.6b6665ae.png";